import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getSearchResults } from "../../api";

export enum Status {
    INACTIVE = "INACTIVE",
    LOADING = "LOADING",
    SUCCESSFUL = "SUCCESSFUL",
    ERROR = "ERROR",
}

export interface imdbSearchResultDto {
    l: string; // title
    id: string; // imdb id
    s: string; // subtitle
    y: number; // year
    q: string; // type, looking for only "TV series"
    i: any[]; // i[0] is image url, i[1] is image width, i[2] is image height
}

export interface SearchState {
    query: string;
    results: imdbSearchResultDto[];
    status?: Status;
}

const initialState: SearchState = {
    query: "",
    results: [],
    status: Status.INACTIVE,
}

export const searchBarSlice = createSlice({
    name: 'searchBar',
    initialState,
    reducers: {
        setSearchState: (state: SearchState, action: PayloadAction<SearchState>) => {
            const filteredResults = action.payload.results.filter((result) => result.q === "TV series");
            state.results = filteredResults;
            state.query = action.payload.query;
        },
        resetSearchState: (state: SearchState) => {
            state.query = initialState.query;
            state.results = initialState.results;
            state.status = initialState.status;
        },
        searchStateStart: (state: SearchState) => {
            state.status = Status.LOADING;
        },
        searchStateEnd: (state: SearchState, action: PayloadAction<Status>) => {
            state.status = action.payload;
        }
    }
});

export const {
    setSearchState,
    resetSearchState,
    searchStateStart,
    searchStateEnd,
} = searchBarSlice.actions;

export const loadSearchResults = (searchTerm: string) => async (dispatch, getState) => {
    dispatch(searchStateStart());
    try {
        const response = await getSearchResults(searchTerm);
        dispatch(setSearchState({query: searchTerm, results: response?.d}));
        dispatch(searchStateEnd(Status.SUCCESSFUL));
    }catch(e){
        dispatch(setSearchState({query: "", results: []}));
        dispatch(searchStateEnd(Status.ERROR));
    }
}